const ticketIncludes = [
    'g_seller_user.hr_employee',
    'pos_detail_sales.wh_product',
    'pos_detail_sales.wh_warehouse',
    'g_state',
    'sl_customer',
    'pos_sale_product_stock_reservations',
]

const employeeSaleIncludes = [
    'g_seller_user.hr_employee',
    'pos_detail_employee_sales.wh_product',
    'pos_detail_employee_sales.wh_warehouse',
    'g_state',
    'g_employee_user.hr_employee',
]

const quotationIncludes = [
    'sl_customer',
    'sl_detail_sale_quotations',
    'pos_sale_type',
    'g_user',
    'g_branch_office',
    //'pos_sale_product_stock_reservations',
    // 'pos_sale_product_stock_reservations',
]

export { ticketIncludes, employeeSaleIncludes, quotationIncludes }
